var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseDialog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CLOSE_DIALOG",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "5 5 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #CLOSE_DIALOG .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pfd_CLOSE",
    transform: "translate(-311 -316)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linie_17",
    "data-name": "Linie 17",
    className: "cls-2",
    x1: 16.971,
    transform: "translate(317.161 333.661) rotate(-45)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_18",
    "data-name": "Linie 18",
    className: "cls-2",
    x1: 16.971,
    transform: "translate(317.161 321.661) rotate(45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDialog);
export default __webpack_public_path__ + "static/media/close-dialog.1d059229585a1f993d140fba4ac26b6a.svg";
export { ForwardRef as ReactComponent };